module.exports = __webpack_public_path__ + "img/portugal-leukaemia-male.021c8130.png";